import i18nFactory from '@yandex-int/i18n';

import { createErrorsMapper } from '../../ErrorsMapper/ErrorsMapper';

import * as keyset from './ErrorsTextMapper.i18n';

const i18n = i18nFactory(keyset);

export const importFileUploadErrorMapper = createErrorsMapper<{}>(
    ({ idx }) => [
        {
            path: [],
            codes: [
                {
                    code: 'CANT_READ_EMPTY',
                    message: ({ params, path }): string =>
                        Array.isArray(params)
                            ? i18n('required-not-empty-field', {
                                  columns: `"${params.join('", "')}"`,
                                  address: `"${path}"`
                              })
                            : ''
                },
                {
                    code: 'CANT_READ_FORMAT',
                    message: (): string => i18n('wrong-value-format')
                },
                {
                    code: 'CANT_READ_UNEXPECTED_DATA',
                    message: (): string => i18n('cant-read-unexpected-data')
                }
            ]
        }
    ],
    (): string => i18n('unknown-error-text')
);
